import { Component,OnInit, Input } from '@angular/core';
import { CoreService } from 'src/app/service/core.service';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-sub-template',
  templateUrl: './sub-template.component.html',
  styleUrls: ['./sub-template.component.css']
})
export class SubTemplateComponent implements OnInit {

   @Input()saleSubData;
   @Input()cmpny;
   @Input()sales_settings;
  measurementDatas: any;
  
   constructor(private coreService: CoreService,private apiService: ApiService,) { }
 
   ngOnInit() {
     
     
 
   }
 
 
 
   ngOnChanges(changes) {
     if (changes['saleSubData'] && this.saleSubData) {
       
 
     }
   }

   measurementData(refno){

      console.log("refno22");
      console.log(refno);

    let searchval = new FormData();
    searchval.append("sub_id", refno);
    this.apiService.getSalesOrderSubMeasurements(searchval).subscribe((res: any) => {
      if (res) {

        console.log("daraaa");
        console.log(res.data);

        this.measurementDatas = res.data;
       
      }
    });

    }

}
